module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/blank/blank.component.css
// module id = ./src/app/home/blank/blank.component.css
// module chunks = main